import { render, staticRenderFns } from "./ChronologyDetail.vue?vue&type=template&id=a58ce066&scoped=true&"
import script from "./ChronologyDetail.vue?vue&type=script&lang=js&"
export * from "./ChronologyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChronologyDetail.vue?vue&type=style&index=0&id=a58ce066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58ce066",
  null
  
)

export default component.exports